module.exports = __webpack_public_path__ + "static/media/avatarDefault.7ca9b032.svg";